import { useState, useEffect } from "react";
import useDeepMemo, { deepEqual } from "../../../utils/useDeepMemo";

const useFormspectrumEditor = ({ initialValue, onChange: handleChange }) => {
  const [spectrum, setSpectrum] = useState(
    initialValue != null ? initialValue : {}
  );

  const onChange = (data) => {
    setSpectrum((state) => {
      const next = { ...state, ...data };
      if (deepEqual(state, next)) return state;
      return next;
    });
  };

  const stableSpectrum = useDeepMemo(spectrum);
  useEffect(() => {
    if (typeof handleChange === "function") {
      handleChange({ id: "spectrum", value: stableSpectrum });
    }
    // eslint-disable-next-line
  }, [stableSpectrum]);

  return { spectrum, initialSpectrum: initialValue, onChange };
};

export default useFormspectrumEditor;
